export default [
    {
        component: () => import(/* webpackChunkName: 'cadastro-obito' */ '@/views/cadastro/obito/Index'),
        path: 'obito',
        redirect: 'obito/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'cadastro-obito' */'@/views/cadastro/obito/List.vue'),
                name: 'cadastro-obito-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'cadastro-obito' */ '@/views/cadastro/obito/Form.vue'),
                name: 'cadastro-obito-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'cadastro-obito' */ '@/views/cadastro/obito/Form.vue'),
                name: 'cadastro-obito-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]